import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asllegalstudies',
  templateUrl: './asllegalstudies.component.html',
  styleUrls: ['./asllegalstudies.component.scss']
})
export class AsllegalstudiesComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
